function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M129.67 53.12a14.63 14.63 0 0012.4 6.88c8.09 0 14.16-6.56 14.16-14.66V42.1l-3.74-30.7a8.73 8.73 0 00-8.63-7.4H16.28a8.73 8.73 0 00-8.63 7.4L4.02 42.1v3.23C4 53.43 9.96 60 18.07 60a14.63 14.63 0 0012.4-6.87"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.46 53.12a14.63 14.63 0 0024.8 0M55.26 53.12a14.63 14.63 0 0024.8 0M80.07 53.12a14.63 14.63 0 0024.8 0M104.86 53.12a14.63 14.63 0 0024.8 0M4.74 36h150.74M36.07 84h44v72h-44zM80.07 84h44v72h-44z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.07 58.67V156h136V58.67"
});

var SvgVodafone = function SvgVodafone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160.23 160",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default SvgVodafone;